export const getScrollingParentElement = (
  node: null | HTMLElement,
  fallbackToRootScrollingElement?: boolean
): null | HTMLElement => {
  if (node instanceof HTMLElement) {
    let current = node;

    while (current.parentElement) {
      const overflow = getComputedStyle(current).getPropertyValue('overflow');
      if (overflow.includes('scroll') || overflow.includes('auto')) {
        return current;
      }

      current = current.parentElement;
    }
  }

  if (!fallbackToRootScrollingElement) {
    return null;
  }

  return document.scrollingElement instanceof HTMLElement
    ? document.scrollingElement
    : document.documentElement;
};
